import React, { Component } from 'react';
import { Carousel, Card } from 'react-bootstrap';
import { connect } from 'react-redux';

const BlogCarousel = ({ blogs }) => {
  return (
    <Carousel interval={null}>
      {blogs.map((blogSet, index) => (
        <Carousel.Item key={index}>
          <div id='container-cards' className="row">
            {Array.isArray(blogSet) ? (
              blogSet.map((card, cardIndex) => {                
                return (
                  <div id='container-card' className="col-md-3" key={cardIndex}>
                    <Card>
                      <a href={card.link} target="_blank" rel="noopener noreferrer">
                        <Card.Body>
                          <Card.Title>{card.title}</Card.Title>
                          <Card.Img alt='imagem noticia blog' variant="top" src={card.image} />
                          <Card.Text>  {card.description}</Card.Text>
                        </Card.Body>
                      </a>
                      <Card.Footer>
                        <a href={card.link} target="_blank" rel="noopener noreferrer">
                          Leia mais
                        </a>
                      </Card.Footer>
                    </Card>
                  </div>
                );
              })
            ) : (
              <p>Nenhum blog encontrado.</p>
            )}
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export class CarouselBlog extends Component {
  constructor(props) {
    super(props);
    this.state = {      
      blogs: [
        [
          {
            title: 'Vexado',
            description: 'O seu site para compra de passagens de ônibus. Somos uma solução completa que oferece diversas opções para os passageiros, além de atender às necessidades das empresas com gerenciamento de bilhetagem, emissão de notas fiscais e serviços de encomendas, tudo em um único lugar.',
            link: 'https://vexado.com.br/',
            image: 'https://imagens-open-graph-sites-agencias.s3.amazonaws.com/vexado.webp'
          },
          {
            title: 'Vexado Blog',
            description: 'Em nosso blog, você encontrará uma variedade de destinos incríveis esperando para serem descobertos. Nossa equipe de redatores apaixonados e experientes viajou extensivamente para trazer a você informações precisas e atualizadas sobre lugares fascinantes.',
            link: '#',
            image: 'https://s3.sa-east-1.amazonaws.com/vexado.com.br/imagens/Blog+vexado.webp'
          },
          {
            title: 'Brasil Passagens Blog',
            description: 'Aqui no Brasil Passagens Blog, destacamos a diversidade de destinos que o Brasil tem a oferecer. Do imponente e exuberante Amazonas ao vibrante e ensolarado Nordeste, passando pela região centro-oeste com seu rico patrimônio natural e cultural, até chegar ao sul encantador com suas paisagens deslumbrantes.',
            link: 'https://www.brasilpassagensblog.com/',
            image: 'https://s3.sa-east-1.amazonaws.com/vexado.com.br/imagens/Blog+Brasil+passagens.webp'
          },
          {
            title: 'Quero Uma Agência',
            description: `Já pensou em ter o seu PRÓPRIO site de 
vendas de passagens?
E o seu PRÓPRIO APLICATIVO?`,
            link: 'https://vexado.com.br/quero-uma-agencia#secao-quero-uma-agencia',
            image: 'https://s3.sa-east-1.amazonaws.com/vexado.com.br/imagens/Vexado_Quero_uma_agencia_.webp'
          }
        ],
        [
          {
            title: 'Brasil Passagens',
            description: 'Facilite a aquisição de suas passagens de ônibus com a Transbasil, tudo isso no conforto do seu lar. Contamos com uma extensa seleção de horários e itinerários para atender a todos os seus requisitos, sempre com preços altamente competitivos. Seja bem-vindo à Transbasil, a escolha líder para suas viagens de ônibus!',
            link: 'https://brasilpassagens.com.br/',
            image: 'https://s3.sa-east-1.amazonaws.com/vexado.com.br/imagens/Brasil+passagens.webp'
          },
          {
            title: 'Bichos News',
            description: 'Bichos News: O seu portal dedicado a trazer informações abrangentes e envolventes sobre uma ampla variedade de tópicos relacionados aos animais.',
            link: 'https://www.bichosnews.net/',
            image: 'https://s3.sa-east-1.amazonaws.com/vexado.com.br/imagens/Bichos+News.webp'
          },
          {
            title: 'Bilhete Na Mão',
            description: 'Nosso serviço de impressão de bilhete de passagens:Rápido e Fácil: Em poucos cliques, você pode imprimir seu bilhete de passagem e estar pronto para embarcar.',
            link: 'https://vexado.com.br/bilhete-na-mao',
            image: 'https://s3.sa-east-1.amazonaws.com/vexado.com.br/imagens/Vexado_bilhete_na_mao.webp'
          },
          {
            title: 'Hot Day News',
            description: 'Descubra um oásis de notícias que vão te cativar, informar e divertir. Com uma abordagem descontraída e conteúdos variados, mergulhe em histórias fascinantes que vão te prender do início ao fim. Prepare-se para se apaixonar pela economia e se encantar pelos bichos. Entre e seja surpreendido!',
            link: 'https://www.hotdaynews.com/',
            image: 'https://s3.sa-east-1.amazonaws.com/vexado.com.br/imagens/Hot+day+news.webp'
          }
        ]
      ]
    };
  }

  render() {
    return (
      <div className="App">
        <h1 id='titulo-blogs'>
          <b id='titulo-blogs'> Blogs Parceiros </b>
        </h1>
        <div className='Container-Carousel'>
          <BlogCarousel blogs={this.state.blogs} />
        </div>
      </div>
    );
  }
}

export default connect(null, {})(CarouselBlog)